import type { InjectionKey, Ref } from 'vue';
import type { DocumentExtraction } from './types';

/**
 * The live Document AI extraction fetched once at session boot. Used by the
 * preview-run renderer to diff proposed extractions against current state.
 */
export const LIVE_EXTRACTION_KEY: InjectionKey<Ref<DocumentExtraction | null>> =
  Symbol('liveExtraction');
